import {Component, Input, OnInit} from '@angular/core';
import {CollapsableService} from "../../services/collapsable/collapsable.service";

@Component({
    selector: 'app-collapsable',
    templateUrl: './collapsable.component.html',
    styleUrls: ['./collapsable.component.scss']
})
export class CollapsableComponent implements OnInit {

    @Input() title: string;
    @Input() group: string;
    @Input() code: string;
    @Input() collapsed: boolean = true;
    @Input() disabled: boolean = false;


    constructor(
        private collapsableService: CollapsableService
    ) {
    }

    ngOnInit() {
        this.collapsableService.isCollapsed.subscribe(
            collapsedOptions => {
                if (collapsedOptions.group === this.group)
                    this.collapsed = collapsedOptions.code !== this.code;
            }
        )
    }

    collapse() {
        if (this.disabled)
            return;

        if (!this.collapsed)
            this.collapsed = !this.collapsed;
        else
            this.collapsableService.isCollapsed.emit({code: this.code, group: this.group});
    }
}
